// Backend limits — Assets
export const ASSET_MAXIMUM_BATCH_SIZE = 100;
export const ASSET_NAME_MAX_LENGTH = 500;
export const ASSET_DESCRIPTION_MAX_LENGTH = 1000;
export const ASSET_BARCODE_MAX_LENGTH = 500;
// Backend limits — Category
export const CATEGORY_ID_BATCH_LIMIT = 200;
export const CATEGORY_CUSTOM_FIELD_ORDER_BATCH_LIMIT = 500;
export const CATEGORY_CUSTOM_ATTRIBUTE_ASSIGNMENT_CATEGORY_BATCH_FETCH_MAX = 500;
export const CATEGORY_STATUS_STEP_SET_BATCH_FETCH_MAX = 1000;
// Backend limits — CustomFields
export const CUSTOM_FIELD_HARD_MAX_TEXT_LENGTH = 500;
export const CUSTOM_ATTRIBUTES_BATCH_FETCH_MAX = 1000;
// Backend limits — Bulk Actions
export const BULK_ACTION_REFERENCES_MAX_AFFECTED_ENTITIES = 10000;
export const BULK_ACTION_REFERENCES_MAX_LINKED_ENTITIES = 5;

// Keys are kept alphabetical so multiple in-flight PRs adding different keys
// land at distinct positions instead of all competing to append at the end
// (which is what caused repeated merge conflicts across this batch).
export const Endpoints = {
  AssetExports: "asset-exports",
  AssetImports: "asset-imports",
  Assets: "assets",
  AssetsActivityStreams: "activity-streams/assets",
  BulkActions: "bulk-actions",
  Categories: "categories",
  CategoryCustomAttributes: "category-custom-attributes",
  CategoryStatusSets: "category-status-sets",
  CategoryStatusStepSets: "category-status-step-sets",
  CategoryTypes: "category-types",
  ClassificationStructures: "classification-structures",
  ClassificationValues: "classification-values",
  CustomAttributeSelectValues: "custom-attribute-select-values",
  CustomAttributes: "custom-attributes",
  Downloads: "downloads",
  FormTemplates: "form-templates",
  ModelIntegration: "model-integration",
  Permissions: "assets-permissions",
  ProjectExports: "project-exports",
  ProjectImports: "project-imports",
  StatusSets: "status-step-sets",
  Statuses: "asset-statuses",
  Systems: "systems",
  SystemsActivityStreams: "activity-streams/systems",
  Users: "users",
} as const;

/**
 * Returns the base path for the Assets backend API.
 *
 * @param baseUrl - Injected base URL (e.g. "https://developer.api.autodesk.com/construction/assets").
 *                  In shared-web, this comes from `getEnvValue("ASSETS_BACKEND")`.
 *                  In Lambda/Node consumers, pass the URL directly.
 * @param projectId - ACC project UUID
 * @param version   - API version (default "v1")
 */
export const getAssetsServiceBasePath = (
  baseUrl: string,
  projectId: string,
  version: "v1" | "v2" | "v3" = "v1"
) => `${baseUrl}/${version}/projects/${projectId}`;
